<template>
  <div class="about-us-box">
    <div>
      <img :src="$t('AboutUs.aboutUrl1')" alt="" />
    </div>
    <div class="value-box">
      <img :src="$t('AboutUs.aboutUrl2')" style="width: 100%" alt="">
    </div>
    <div class="value-box">
      <img :src="$t('AboutUs.aboutUrl3')" style="width: 100%" alt="">
    </div>
    <!-- <div
      class="top-img-box common-bg-img-center relative"
      :style="`background-image: url(${bgUrl})`"
    >
      <div class="title">{{ $t("AboutUs.Clauses") }}</div>
    </div>
    <div class="mission-text text-gray">{{ $t("AboutUs.Clauses1") }}</div>
    <div class="values-box">
      <div class="about-title text-center">
        {{ $t("AboutUs.SharedValues") }}
      </div>
      <div class="content-box">
        <div class="item">
          <div>
            <span class="text-tone lg-size">C</span>
            <span class="text-tone">：Challenge</span>
            <strong v-if="webSession != 1" class="text-black ma-left">{{
              $t("LastTranslate.Challenge")
            }}</strong>
          </div>
          <div class="text text-gray">{{ $t("AboutUs.Challenge") }}</div>
        </div>
        <div class="item">
          <div>
            <span class="text-tone lg-size">A</span>
            <span class="text-tone">：Activities</span>
            <strong v-if="webSession != 1" class="text-black ma-left">{{
              $t("LastTranslate.Activitier")
            }}</strong>
          </div>
          <div class="text text-gray">{{ $t("AboutUs.Activitier") }}</div>
        </div>
        <div class="item">
          <div>
            <span class="text-tone lg-size">A</span>
            <span class="text-tone">：Acknowledgement</span>
            <strong v-if="webSession != 1" class="text-black ma-left">{{
              $t("LastTranslate.Acknowledgement")
            }}</strong>
          </div>
          <div class="text text-gray">{{ $t("AboutUs.Acknowledgement") }}</div>
        </div>
        <div class="item">
          <div>
            <span class="text-tone lg-size">A</span>
            <span class="text-tone">：Aesthetic</span>
            <strong v-if="webSession != 1" class="text-black ma-left">{{
              $t("LastTranslate.Aesthetic")
            }}</strong>
          </div>
          <div class="text text-gray">{{ $t("AboutUs.Aesthetic") }}</div>
        </div>
        <div class="text-tone last-text">{{ $t("AboutUs.Value") }}</div>
      </div>
    </div>
    <div class="company-info-box">
      <div class="about-title text-center">
        {{ $t("AboutUs.CompanyProfile") }}
      </div>
      <img src="../../../../assets/img/about2.png" alt="" />
      <div class="text-box text-gray">
        <div class="text-item">{{ $t("AboutUs.CompanyProfile1") }}</div>
        <div class="text-item">{{ $t("AboutUs.CompanyProfile2") }}</div>
        <div class="text-item">{{ $t("AboutUs.CompanyProfile3") }}</div>
        <div class="text-item">{{ $t("AboutUs.CompanyProfile4") }}</div>
      </div>
    </div> -->
    <div class="manage-team-box">
      <div class="about-title text-center">{{ $t("AboutUs.Management") }}</div>
      <div class="team-swiper-box">
        <swiper :options="swiperOption" class="about-team-swiper">
          <swiper-slide v-for="(item, i) in teamList" :key="i">
            <div class="team-item text-center">
              <!-- <div class="img-box"> -->
              <img class="head-img" :src="item.imgUrl" alt="" />
              <!-- </div> -->
              <div class="name">{{ $t(item.name) }}</div>
              <div class="name">{{ $t(item.position) }}</div>
              <div class="desc-text text-left" v-html="$t(item.detail)"></div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="value-box">
      <img :src="$t('AboutUs.aboutUrl4')" style="width: 100%" alt="">
    </div>
    <!-- <div class="honorary-advisor-box">
      <div class="about-title text-center">荣誉顾问</div>
      <van-swipe :autoplay="0" class="honorary-advisor-swipe" :loop="false">
        <van-swipe-item v-for="(item,i) in honoraryList" :key="i">
          <div class="advisor-item common-flex-box">
            <img class="img" :src="item.mainUrl" alt="">
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="content" v-html="item.content"></div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <!-- <div class="market-info-box">
      <div class="about-title text-center">{{ $t("AboutUs.Marketplace") }}</div>
      <img src="../../../../assets/img/about3.jpg" alt="" />
    </div> -->
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      webSession: "",
      bgUrl: require("../../../../assets/img/about-bg.png"),
      swiperOption: {
        autoHeight: true, //高度随内容变化
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      teamList: [
        {
          name: "AboutUs.Name",
          position: "AboutUs.position",
          imgUrl: require("@/assets/img/HK_Officia.jpg"),
          detail: "AboutUs.Resume",
        },
        {
          name: "AboutUs.Name1",
          position: "AboutUs.position1",
          imgUrl: require("@/assets/img/liangjiaxin.jpg"),
          detail: "AboutUs.Resume1",
        },
        {
          name: "AboutUs.Name2",
          position: "AboutUs.position2",
          imgUrl: require("@/assets/img/Jackie_Cheung.jpg"),
          detail: "AboutUs.Resume2",
        },
        {
          name: "AboutUs.Name4",
          position: "AboutUs.position4",
          imgUrl: require("@/assets/img/Wong.png"),
          detail: "AboutUs.Resume4",
        },
        // {
        //   name: "AboutUs.Name3",
        //   position: "AboutUs.position3",
        //   imgUrl: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/member4.jpg',
        //   detail: "AboutUs.Resume3",
        // },
        {
          name: "AboutUs.Name5",
          position: "AboutUs.position5",
          imgUrl: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/member6.jpg',
          detail: "AboutUs.Resume5",
        },
        // {
        // 	name: 'AboutUs.Name6',
        // 	position: 'AboutUs.position6',
        // 	imgUrl: require('@/assets/img/yan.jpg'),
        // 	detail: 'AboutUs.Resume6'
        // },
        // {
        // 	name: 'AboutUs.Name7',
        // 	position: 'AboutUs.position7',
        // 	imgUrl: require('@/assets/img/yan1.jpg'),
        // 	detail: 'AboutUs.Resume7'
        // }
      ],
      honoraryList: [
        {
          name: "许庆国",
          mainUrl: require("../../../../assets/img/about5.png"),
          content:
            "毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。",
        },
        {
          name: "毛星",
          mainUrl: require("../../../../assets/img/about6.png"),
          content:
            "毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。",
        },
        {
          name: "艾萍",
          mainUrl: require("../../../../assets/img/about7.png"),
          content:
            "毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。",
        },
        {
          name: "董芝",
          mainUrl: require("../../../../assets/img/about8.png"),
          content:
            "毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。毕业于中央民族大学。曾任宁夏社科院历史所所长、中国民族史学会理事等职。",
        },
      ],
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  watch: {
    "$store.state.AcceptLanguage": function () {
      //监听vuex中userName变化而改变header里面的值
      this.webSession = this.$store.state.AcceptLanguage;
    },
  },
};
</script>
<style lang="scss" scoped>
.about-us-box {
  .top-img-box {
    height: 300px;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-weight: bold;
      font-size: 52px;
    }
  }

  .mission-text {
    padding: 32px 24px 32px 46px;
    line-height: 38px;
  }

  .about-title {
    margin-bottom: 24px;
    padding: 29px 0;
    font-size: 32px;
    font-weight: bold;
  }

  .values-box {
    .content-box {
      padding: 0 24px 31px 30px;

      .item {
        margin-bottom: 63px;

        .lg-size {
          font-size: 64px;
        }

        .ma-left {
          margin-left: 18px;
        }

        .text {
          margin-top: 24px;
          line-height: 36px;
        }
      }

      .last-text {
        font-size: 32px;
        line-height: 36px;
      }
    }
  }

  .company-info-box {
    padding: 32px;
    background-color: #f5f5f5;

    .text-box {
      margin-top: 33px;

      .text-item {
        line-height: 36px;

        &:not(:first-child) {
          margin-top: 30px;
        }
      }
    }
  }

  .manage-team-box {
    padding: 32px 0;

    .team-swiper-box {
      padding: 0 35px;

      .team-item {
        .head-img {
          width: 318px;
          height: 428px;
          object-fit: cover;
        }

        .name {
          margin: 33px 0 22px;
          font-size: 28px;
          font-weight: bold;
        }

        .desc-text {
          line-height: 38px;
        }
      }
    }
  }

  .honorary-advisor-box {
    padding: 32px;
    background-color: #f5f5f5;

    .advisor-item {
      padding: 32px 40px 32px 32px;
      background-color: #fff;

      .img {
        width: 154px;
        height: 206px;
      }

      .right-text {
        flex: 1;

        .name {
          font-size: 28px;
          font-weight: bold;
          padding: 9px 0 23px 27px;
        }

        .content {
          padding-left: 24px;
          height: 145px;
          line-height: 36px;
          overflow: hidden;
        }
      }
    }
  }

  .market-info-box {
    padding: 32px 0 64px;

    img {
      width: 100%;
    }
  }
}
</style>
